import { IStaff, StaffService } from "../../../services/staff.service";

interface IResolve {
    staff: IStaff;
}

class StaffItemController {

    private resolve: IResolve;
    private staff: IStaff;
    user: any;
    roles: any;
    
    rolesList = ['backoffice', 'superuser', 'finance', 'timesheets'];
    password: any = '';
    confirmPassword: any = '';

    constructor(
        private StaffService: StaffService,
        private $state: ng.ui.IStateService,
        private SweetAlert: any,
        private $scope: any
    ) {
        'ngInject';
    }

    public $onInit = () => {        
        this.staff = this.resolve.staff;

        if(this.staff.id) {
            this.getUser();
            
        }
        
    }

    public getUser = () => {
        this.StaffService.getUser(this.staff.id).then(user => {
            this.user = user;

            if(this.user.id) {
                this.getRoles();
            }
        })
    }

    public getRoles = () => {
        this.StaffService.getRoles(this.staff.id).then(roles => {
            this.roles = roles;
        })
    }

    public save = () => {
        if(this.$scope.staffBasicInfoForm.$valid) {

    
            if(this.staff.id) {
                this.StaffService.put(this.staff.id, this.staff).then(staff => {
                    this.staff = staff;
                    this.StaffService.putRoles(this.staff.id, this.roles).then(roles => { 
                        this.roles = roles;
                    })

                    if(this.password.length > 0) {
                        this.StaffService.putPassword(this.staff.id, this.password).then(roles => { 
                            this.password = '';
                            this.confirmPassword = '';
                        })
                    }
                })
            } else {
                this.StaffService.post(this.staff).then(staff => {
                    this.staff = staff;
                    this.$state.go('settings.staff.list.item', {id: this.staff.id}, {reload: true});
                });
            }
        }
    }

    public createuser = () => {
        var user = {
            userName : this.staff.email,
            email : this.staff.email,
            phoneNumber : this.staff.phoneNumber,
            password: this.password,
            twoFactorEnabled : false
        }
        if(!this.user && this.staff.id) {
            this.StaffService.createUser(this.staff.id, user).then(user => {
                this.password = '';
                this.confirmPassword = '';
                this.user = user;
            })
        }
    }

    public deleteUser = () => {
        if(this.staff.id && this.user) {
            this.StaffService.deleteUser(this.staff.id).then(user => {
                
            })
        }
    }

    public delete = () => {
        if(this.staff.id) {
            if(this.user) {
                this.StaffService.deleteUser(this.staff.id).then(user => {
                    this.StaffService.delete(this.staff.id).then(user => {
                        this.$state.go('^', {}, {reload: true});
                    });
                })
            } else {
                this.StaffService.delete(this.staff.id).then(user => {
                    this.$state.go('^', {}, {reload: true});
                });
            }
        }
    }
}

export const staffItemComponent = { 
    bindings: {
        resolve : "<",
        close: "&"
    },
    controller: StaffItemController,
    template: require('./staff.item.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/settings/staff/staff.item.component.ts